<template>
    <section class="inplay-section all-type-game" loading="lazy">
        <div class="remove-padding">
            <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-2">
                    <LeftSideMenu />
                </div>

                <!-- /end here/ -->

                <div class="col-sm-12 col-md-9 col-lg-10">
                    <div class="right-side-menu-sec">
                     <Banner />

                        <div class="inplay-page-details">
                            <div class="inply-heading-with-logo sports-icons-head upcoming-sports-title" v-if="allData?.inplay?.length > 0">
                                <ul class="inplay_title_header">
                                    <li><img src="@/assets/images/inplayico.40798d4.webp" alt="inplay"> <span>{{ $t('inplay','Inplay')}}</span></li>
                                    <div class="inplay_wallat_btn" v-if="$siteSettings?.data?.business_type == 2 && $auth.status">
                                        <button class="btn deposit_btn_inplay green_btn" @click="$router.push({name: 'wallet-deposit'})">Deposit</button>
                                        <button class="btn deposit_btn_inplay red_btn" @click="$router.push({name: 'wallet-withdraw'})">Withdraw</button>
                                    </div>
                                </ul>
                            </div>
                            <template v-for="(sport, sIndex) in inplayMatches" :key="sIndex">
                                <div class="inpy-game-name-cmn-sec cricket inPlay-match1" v-if="sport.matches.length">
                                    
                                    <div class="inply-header-row">
                                        <div class="inply-game-l-sec">
                                            <div class="inply-heading-with-logo sports-icons-head">
                                                <ul>
                                                    <li>
                                                        <img loading="lazy" :src="getSportImage(sport?.matches?.[0]?.sport_id)" alt="">
                                                        {{ $t(sIndex?.toLowerCase(), sIndex)  }}
                                                        <!-- <span>{{ sport[0].sport_id == 1 ? $t('soccer','Soccer' ) :$t(sport[0].sport_name,sport[0].sport_name ) }}</span> -->
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="header-live-virtual-title">
                                            <ul class="live_virtual">
                                                <li>
                                                    <input type="checkbox" @change="changeFilterKey('live', sport.filterKey)" class="filter-checkbox">
                                                    <label>{{$t('live','LIVE')}}</label>
                                                </li>
                                                <li>
                                                    <input type="checkbox" @change="changeFilterKey('virtual',sport.filterKey)" class="filter-checkbox">
                                                    <label>{{$t('virtual','VIRTUAL')}}</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <SportItem :sportsData="filterMatches(sport)" />
                                    
                                </div>
                            </template>

                            <template v-if="!globalLoader">

                                <div class="live-card-and-live-casino-section">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" v-if="this.sectionWiseGamesList?.[1].gamesList">
                                            <div class="live-card-main-wrapper">

                                                <div class="title-container-main">
                                                    <div class="card-main-header">
                                                        <h3>{{ $t('live','Live')}} <strong>{{ $t('cards','Cards')}}</strong></h3>
                                                    </div>
                                                    <div class="list-more-item-h">
                                                        <a href="/games/live-card">{{ $t('more','More')}} ...</a>
                                                    </div>
                                                </div>

                                                <div class="grid-main-btn-wrapper">
                                                
                                                    <div  class="grid-sub-btn123 " v-for="item in sectionWiseGamesList?.[1].gamesList?.slice(0, 6)" :key="item.id">
                                                        <a @click="loadGame(item)" href="javascript:void(0);" :aria-label="`Open ${item.game_name}`">
                                                            <span class="casino-game-name">{{ item.game_name }}</span>
                                                            <!-- <span class="casino-game-img">
                                                                <img :src="item.image" :alt="`Cover image for ${item.game_name}`"  />
                                                            </span> -->
                                                        </a>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" v-if="this.sectionWiseGamesList?.[0].gamesList">
                                            <div class="live-card-main-wrapper casino-p-top">

                                                <div class="title-container-main">
                                                    <div class="card-main-header">
                                                        <h3>{{ $t('live','Live')}} <strong>{{ $t('casino','Casino')}}</strong></h3>
                                                    </div>
                                                    <div class="list-more-item-h">
                                                        <a href="/games/live-casino">{{ $t('more','More')}} ...</a>
                                                    </div>
                                                </div>

                                                <div class="grid-main-btn-wrapper">
                                                    <div  class="grid-sub-btn123"   v-for="item in sectionWiseGamesList?.[0].gamesList?.slice(0, 6)" :key="item.id" >
                                                        <a  @click="loadGame(item)" href="javascript:void(0);" :aria-label="`Open ${item.game_name}`">
                                                            <span class="casino-game-name">{{ item.game_name }}</span>
                                                            <!-- <span class="casino-game-img">
                                                                <img :src="item.image" :alt="`Image of ${item.game_name}`" />
                                                            </span> -->
                                                        </a>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="premium-img-container mt-3 mb-3">
                                    <router-link to="/games/evolution">
                                        <img loading="lazy" src="@/assets/images/evolution_img.png" alt="">
                                    </router-link>
                                </div>

                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" v-if="this.sectionWiseGamesList?.[0].gamesList">
                                    <div class="live-card-main-wrapper casino-p-top">
                                        <div class="title-container-main">
                                            <div class="card-main-header">
                                                <h3><strong>{{ $t('casino','Providers')}}</strong></h3>
                                            </div>
                                        </div>
                                        <div class="grid-main-btn-wrapper provider_banner_slider_sec">
                                            <div  class="grid-sub-btn123"   v-for="item in sectionWiseGamesList?.[4]?.gamesList" :key="item.id" >
                                                <a  @click="loadGame(item)" href="javascript:void(0);" :aria-label="`Open ${item.game_name}`">
                                                    <span class="casino-game-name">{{ item.game_name }}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </template>

                            <!-- //////upcoming-sec -->
                            <div ref="upcomigMatch"></div>
                            <div class="inply-heading-with-logo up-coming-matches sports-icons-head upcoming-sports-title mt-3" v-if="Object.keys(upcomingMatches).length || Object.keys(secondaryUpcomingMatches).length">
                                <ul>
                                    <li><img src="@/assets/images/upcoming.webp" alt="upcoming"></li>
                                    <li><span>{{ $t('upcoming','UPCOMING')}}</span></li>
                                </ul>
                            </div>

                            <div class="upcoming-matches-sec">
                                <template v-for="(sport, sIndex) in upcomingMatches" :key="sIndex">
                                    <div class="inpy-game-name-cmn-sec up-coming-cricket inPlay-match1" v-if="sport.matches.length">
                                        <div class="inply-header-row">
                                            <div class="inply-game-l-sec">
                                                <div class="inply-heading-with-logo sports-icons-head">
                                                    <ul>
                                                        <li>
                                                            <img loading="lazy" :src="getSportImage(sport?.matches?.[0]?.sport_id)" alt="">
                                                            {{ $t(sIndex?.toLowerCase(), sIndex)  }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="header-live-virtual-title">
                                                <ul class="live_virtual">
                                                    <li>
                                                        <input type="checkbox" @change="changeFilterKey('live', sport.filterKey)" class="filter-checkbox">
                                                        <label>{{$t('live','LIVE')}}</label>
                                                    </li>
                                                    <li>
                                                        <input type="checkbox" @change="changeFilterKey('virtual',sport.filterKey)" class="filter-checkbox">
                                                        <label>{{$t('virtual','VIRTUAL')}}</label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <UpcomingSportItem :sportsData="filterMatches(sport)" />
                                    </div>
                                </template>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- User journay Info -->
    <div class="user-journey-info-bx" v-if="tutorials.length">
        <div class="cmn-head-3">
            <h3>User Journey Info</h3>
        </div>
        <div class="row">
            <div v-for="(tut, idx) in tutorials" :key="tut.videoKey" class="col-6 col-sm-4 col-md-3">
                <div class="support-btn-con">
                    <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#faqVideoModal"
                        @click="playVideo(tut.videoKey, tut.imageKey, tut.title)">
                        {{ idx + 1 }}. {{ tut.title }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade modal-style" id="faqVideoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">{{videoTitle}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <video controls :poster="videoThumbnail" :src="videoUrl" class="video-display"></video>
                </div>
            </div>
        </div>
    </div>
    <template v-if="!globalLoader">
        <section class="download-app-sec" loading="lazy">
            <div class="download-row-wrapper">
                <div class="download">
                    <img loading="lazy" src="@/assets/images/download-app.webp" alt="download">
                </div>
                <div class="download-fair-ply">
                    <div class="club-title-name">
                        <h2 class="">{{ $t('download-the-app','DOWNLOAD THE APP')}}</h2>
                    </div>
                    <div class="download-text">
                        <span>{{ $t(`${$siteSettings?.data?.domain_name}`,`Now download the ${$siteSettings?.data?.domain_name} Official app and get easier, quicker access to your winnings`)}}!</span>
                        <div class="down-load-btn-text">
                            <a href="#install-apk-model" data-bs-toggle="modal"> {{ $t('download-the-app','Download App')}}</a>
                        </div>
                        <p class="ply-text">{{ $t('download-now-outside-google-playstore','Download now outside Google Playstore')}}</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="payment-mnethod-sec" loading="lazy">
            <div class="remove-padding">
                <div class="cmn-head-3">
                    <h3>{{ $t('payment-methods','PAYMENT METHODS')}}</h3>
                </div>
                <div class="payment-app-name">
                    <ul>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/paytm.webp" alt="paytm">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/paypal.webp" alt="paypal">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/gpay.webp" alt="gpay">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/upi.webp" alt="upi">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/ethereum.webp" alt="ethereum">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/bitcoin.webp" alt="bitcoin">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/bitcoin.webp" alt="bitcoin">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/microgaming.webp" alt="microgaming">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/bet-soft.webp" alt="bet-soft">
                            </div>
                        </li>
                        <li>
                            <div class="payment-app-border">
                                <img loading="lazy" src="@/assets/images/tether.webp" alt="tether">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </template>
</template>
<script>
import { io } from "socket.io-client";
const socket = io(process.env.VUE_APP_CLICK_API_SOCKET, { transports: ['websocket'], upgrade: false });
import { mapGetters } from 'vuex';
import loadCasinoGame from '@/shared/services/casinoGamesHandler';
import { checkForLockedMatches,checkEventManageforSports,checkInEventMangeForSection} from '@/shared/services/eventLocks.js';
import { defineAsyncComponent } from 'vue';

export default {
    name: 'Home',
    components: {
		Banner: defineAsyncComponent(() =>
			import('./components/Banner.vue')
		),
        LeftSideMenu: defineAsyncComponent(() =>
			import('@/shared/components/menu/LeftSideMenu.vue')
		),
        SportItem: defineAsyncComponent(() =>
			import('@/modules/sports/components/SportItem.vue')
		),
        UpcomingSportItem: defineAsyncComponent(() =>
			import('./components/UpcomingSportItem.vue')
		),
    },
    data() {
        return {
            breakpoints: {
                0: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                375: {
                    itemsToShow: 3,
                    snapAlign: 'start',
                },
                480: {
                    itemsToShow: 4,
                    snapAlign: 'start',
                },
                668: {
                    itemsToShow: 5,
                    snapAlign: 'start',
                }
            },
            sectionsList: [],
            sectionWiseGamesList: [
                {
                    slugName: 'live-casino',
                    gamesList: null,
                },
                {
                    slugName: 'live-card',
                    gamesList: null,
                },
                {
                    slugName: 'slot-games',
                    gamesList: null,
                },
                {
                    slugName: 'crash-games',
                    gamesList: null,
                },
                {
                    slugName: 'providers',
                    gamesList: null,
                },
            ],
            inplayMatches: {},
            upcomingMatches: {},
            allData: {},
            upcomingMatchesData: [],
            observer: null,
            secondaryInplayMatches:{},
            secondaryUpcomingMatches:{},
            eventManage: null,
            filterKey: [],
            videoUrl: null,
            videoTitle: null,
            videoThumbnail: null
        };
    },
    computed: {
        ...mapGetters(['favouriteGames','gamesData', 'globalLoader']),
        tutorials() {
            const journey = this.$siteSettings?.data?.user_journey ?? {};

            const allTutorials = [
                { title: "How to Login",            videoKey: "login_video",        imageKey: "login_img"      },
                { title: "How to Register",         videoKey: "register_video",     imageKey: "register_img"   },
                { title: "Introduction",            videoKey: "introduction_video", imageKey: null             },
                { title: "How to Withdraw",         videoKey: "withdrawal_video",   imageKey: null             },
                { title: "How to Play",             videoKey: "play_video",         imageKey: "play_img"       },
                { title: "How to Play Bonus",       videoKey: "use_bonus_video",    imageKey: null             },
                { title: "How to Deposit English",  videoKey: "deposit_video_e",    imageKey: null             },
                { title: "How to Deposit Hindi",    videoKey: "deposit_video_h",    imageKey: null             },
            ];

            return allTutorials.filter(t => Boolean(journey[t.videoKey]));
        }
    },
    mounted() {
        socket.connect();
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.upcomingMatchesData?.length) {
                    this.observer.unobserve(entry.target);
                    this.getUpcomingMatches();
                }
            });
        });
    },
    created() {
        this.eventManage = this.$store?.getters?.eventManage;
        this.getInplayMatches()
        this.getCasinoGamesServiceCall();
    },
    methods: {
        filterMatches(data) {
            const { matches, filterKey } = data;

            if (!filterKey || !Array.isArray(filterKey) || filterKey.length === 0) {
                return matches;
            }

            return matches.filter(item => {
                const isLive = item.isMatchLive || item.inplay;
                const isVirtual = item.is_exclusive;

                if (filterKey.includes('live') && filterKey.includes('virtual')) {
                    return isLive || isVirtual;
                }
                if (filterKey.includes('live')) {
                    return isLive && !isVirtual;
                }
                if (filterKey.includes('virtual')) {
                    return isVirtual;
                }
                return true;
            });
        },
        changeFilterKey(type, filterKey) {
            const index = filterKey.indexOf(type);
            index > -1 ? filterKey.splice(index, 1) : filterKey.push(type);
        },
        checkEventManageforSports,
        checkInEventMangeForSection,
        checkForLockedMatches,
        getInplayMatches() {
            this.loading = true;
             this.$store.dispatch('setGlobalLoader', true);
            this.$apiCall('get', 'INPLAY_MATCHES_LIST', null, 'sports').then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (response && response.status == 200) {
                    this.allData = response.data.data;

                    var inplay_match_list = response.data.data.inplay;
                    this.inplayMatches['cricket'] = { matches: [], filterKey: [] };
                    this.inplayMatches['soccer'] = { matches: [], filterKey: [] };
                    this.inplayMatches['tennis'] = { matches: [], filterKey: [] };    

                    let lockedMatchIds = [];
                    let lockedLeagueIds = [];
                    if(this.$auth.status && this.eventManage) {
                        lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                        lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                        lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                        lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                    }
                    for (var i = 0; i < inplay_match_list.length; i++) {
                        if(checkEventManageforSports(inplay_match_list[i].sport_id) && checkForLockedMatches(inplay_match_list[i].matchId, inplay_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                            inplay_match_list[i]['favourite']= this.favouriteList?.includes(parseInt(inplay_match_list[i].event_id))                    
                            let sportKey;
                            if (inplay_match_list[i].sport_id == 4) {
                                sportKey = 'cricket';
                            } else if (inplay_match_list[i].sport_id == 1) {
                                sportKey = 'soccer';
                            } else if (inplay_match_list[i].sport_id == 2) {
                                sportKey = 'tennis';
                            } else {
                                sportKey = inplay_match_list[i].sport_name;
                            }
                            if (!this.inplayMatches[sportKey]) {
                                this.inplayMatches[sportKey] = { matches: [], filterKey: [] };
                            }
                            this.inplayMatches[sportKey].matches.push(inplay_match_list[i]);
                        }
                    }

                    let targetElement = this.$refs.upcomigMatch;
                    if (targetElement) {
                        this.observer.observe(targetElement);
                    }

                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        getUpcomingMatches(){
            this.loading = true;
            this.$apiCall('get', 'GET_UPCOMING_SPORTS', null, 'sports', { day: 'upcoming' }).then(response => {
                this.loading = false;
                if (response && response.status == 200) {
                    this.upcomingMatchesData = response.data.data.sort().reverse()

                    this.upcomingMatches['cricket'] = { matches: [], filterKey: [] };
                    this.upcomingMatches['soccer'] = { matches: [], filterKey: [] };
                    this.upcomingMatches['tennis'] = { matches: [], filterKey: [] };  

                    // var cricket = []
                    // var soccer = []
                    // var tennis = []
                    let lockedMatchIds = [];
                    let lockedLeagueIds = [];
                    if(this.$auth.status && this.eventManage) {
                        lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                        lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                        lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                        lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                    }
                    for (var i = 0; i < this.upcomingMatchesData.length; i++) {
                        if(this.checkEventManageforSports(this.upcomingMatchesData[i].sport_id) && this.checkForLockedMatches(this.upcomingMatchesData[i].matchId, this.upcomingMatchesData[i].league_id, lockedMatchIds, lockedLeagueIds)) {

                            let sportKey;
                            if (this.upcomingMatchesData[i].sport_id == 4) {
                                sportKey = 'cricket';
                            } else if (this.upcomingMatchesData[i].sport_id == 1) {
                                sportKey = 'soccer';
                            } else if (this.upcomingMatchesData[i].sport_id == 2) {
                                sportKey = 'tennis';
                            } else {
                                sportKey = this.upcomingMatchesData[i].sport_name;
                            }
                            if (!this.upcomingMatches[sportKey]) {
                                this.upcomingMatches[sportKey] = { matches: [], filterKey: [] };
                            }
                            this.upcomingMatches[sportKey].matches.push(this.upcomingMatchesData[i]);
                            
                            
                            // if (this.upcomingMatchesData[i].sport_id == 4) {
                            //     cricket.push(this.upcomingMatchesData[i])
                            // } else if (this.upcomingMatchesData[i].sport_id == 1) {
                            //     soccer.push(this.upcomingMatchesData[i])
                            // } else if (this.upcomingMatchesData[i].sport_id == 2) {
                            //     tennis.push(this.upcomingMatchesData[i])
                            // } else {
                            //         if(!this.secondaryUpcomingMatches[this.upcomingMatchesData[i].sport_name]){
                            //             this.secondaryUpcomingMatches[this.upcomingMatchesData[i].sport_name] = [];
                            //         };
                            //         this.secondaryUpcomingMatches[this.upcomingMatchesData[i].sport_name].push(this.upcomingMatchesData[i])
                            // }
                        }
                    }
                    // this.upcomingMatches['Cricket'] = cricket
                    // this.upcomingMatches['Soccer'] = soccer
                    // this.upcomingMatches['Tennis'] = tennis
                    this.observer = null;

                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        getCasinoGamesServiceCall() {                            
            let gamesData = this.gamesData;
            if (this.$auth.status) {
                checkInEventMangeForSection(gamesData)
                this.$store.dispatch('setGamesData', gamesData);
            };
            this.sectionsList = this.gamesData?.sections;                      
            this.setSectionList();
        },
        setSectionList() {
            try {
                for (let i = 0; i < this.sectionsList.length; i++) {
                    let gamesList = [];
                    if (this.sectionsList[i].menus) {
                        for (let j = 0; j < this.sectionsList[i].menus.length; j++) {
                            gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
                        }
                    } else {
                        gamesList = this.sectionsList[i].games;
                    }

                    let gameListNew = [];
                    if (this.$auth.status) {

                        for (var k = 0; k < gamesList.length; k++) {
                            if (this.favouriteGames?.includes(gamesList[k].id)) {
                                gamesList[k]['favourite'] = true
                            } else {
                                gamesList[k]['favourite'] = false
                            }
                            gameListNew.push(gamesList[k]);
                        }
                    } else {
                        gameListNew = gamesList;
                    }
                    const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
                    gameListNew.sort((a, b) => naturalCollator.compare(a.porder, b.porder));
                    switch (this.sectionsList[i].slug) {
                        case 'live-casino':
                            this.sectionWiseGamesList[0].gamesList = gameListNew;
                            break;
                        case 'live-card':
                            this.sectionWiseGamesList[1].gamesList = gameListNew;
                            break;
                        case 'slot-games':
                            this.sectionWiseGamesList[2].gamesList = gameListNew;
                            break;
                        case 'crash-games':
                            this.sectionWiseGamesList[3].gamesList = gameListNew;
                            break;
                        case 'providers':
                            this.sectionWiseGamesList[4].gamesList = gameListNew;
                            break;
                    }
                }

            } catch (error) {
                console.log(error);
            }
        },
        getSportImage(sportId) {
            const imageMap = {
                4: require("@/assets/images/sports-cricket.png"),
                1: require("@/assets/images/sports-soccer.png"),
                2: require("@/assets/images/sports-tennis.png"),
                1477: require("@/assets/images/sports-rugby-league.png"),
                6: require("@/assets/images/sports-boxing.png"),
                5: require("@/assets/images/sports-rugby-union.png"),
                3: require("@/assets/images/sports-golf.png"),
                27454571: require("@/assets/images/sports-esports.png"),
                2152880: require("@/assets/images/sports-gaelic-football.png"),
                998917: require("@/assets/images/sports-volleyball.png"),
                7524: require("@/assets/images/sports-ice-hockey.png"),
                7522: require("@/assets/images/sports-basketball.png"),
                7511: require("@/assets/images/sports-baseball.png"),
                6423: require("@/assets/images/sports-american-football.png"),
                6422: require("@/assets/images/sports-snooker.png"),
                11: require("@/assets/images/sports-cycling.png"),
                8: require("@/assets/images/sports-motor-sport.png"),
                2378961: require("@/assets/images/sports-politics.png"),
                468328: require("@/assets/images/sports-handball.png"),
                61420: require("@/assets/images/sports-australian-rules.png"),
                3503: require("@/assets/images/sports-darts.png"),
                10: require("@/assets/images/sports-special-bets.png"),
                26420387: require("@/assets/images/sports-mixed-martial-arts.png"),
                4339: require("@/assets/images/sports-greyhound-racing.png"),
                7: require("@/assets/images/sports-horse-racing.png"),
                4345: require("@/assets/images/election_icon.png"),
                4344: require("@/assets/images/winner_cup.png"),
                4343: require("@/assets/images/fifa_cup.png"),
                27454574: require("@/assets/images/kabaddi_icon1.png"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.png");
        },
        loadGame(game) {
            if(game.category == 'Providers'){
                this.$router.push({name: 'Games', params: {type: 'live-casino'}, query: {providerId: game.provider_id}});
            }else{
                if(!this.$auth.status) {
                    this.$router.push({name:'login'})
                    return;
                }
                loadCasinoGame.loadGame(game, this.$auth.user);
            }
        },
        playVideo(videoKey, imageKey, title) {
            const base = this.$siteSettings?.data?.user_journey;
            this.videoUrl       = this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[videoKey];
            this.videoThumbnail = imageKey ? this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[imageKey] : null;
            this.videoTitle     = title;
        }
    },
    beforeUnmount() {
        socket.disconnect();
    }
}
</script>

<style scoped>
.whatsapp-modal-list{
  list-style: none;
  display: flex;
  flex-direction: column;
  gap:10px;
}
.whatsapp-modal-list li{
  background: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
}
.whatsapp-modal-list li .check-click-icn{
  color: #63ca58;
}
.whatsapp-modal-number {
  background: #f36c21;
  padding: 5px 10px;
  border-radius: 20px;
  display: flex;
  margin: 15px auto;
  max-width: 300px;
  text-align: center;
  color: #fff;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.whatsapp-modal-number:hover{
  color: #fff;
}
.whatsapp-modal-number .whatsapp-modal-btn-icn{
  font-size: 20px;
}
#whatsapp-modal .modal-content{
  max-width: 500px;
}
.video-display{
  height: 160px;
  width: 100%;
}
</style>